import { NgModule } from '@angular/core';

import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { RouterModule } from "@angular/router";
import { SharedModule } from '@app/shared/shared.module';
import { LogoModule } from '@app/shared/components/logo/logo.module';

import { DropdownModule } from '@app/shared/components/dropdown/dropdown.module';
// import { SwitchModule } from '@app/shared/components/switch/switch.module';
import { ModalModule } from 'ngx-bootstrap/modal';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { AppLayoutComponent } from './app-layout/app-layout-component';


import { VerticalLayoutComponent } from './components/vertical-layout/vertical-layout.component';
import { SideNavComponent } from './components/side-nav/side-nav.components';
import { HeaderNavComponent } from './components/header-nav/header-nav.component';

import { NavToggleComponent } from './components/nav-toggle/nav-toggle.component';
import { ContentComponent } from './components/content/content.component';
import { FooterComponent } from './components/footer/footer.component';
import { PageHeaderComponent } from './components/page-header/page-header.component';

import { ThemeConfiguratorComponent } from './components/theme-configurator/theme-configurator.component';
import { MobileNavComponent } from './components/mobile-nav/mobile-nav.component';

const mandatoryComponents = [
    AppLayoutComponent,
  
    VerticalLayoutComponent,
 
    SideNavComponent,
    HeaderNavComponent,
  
    NavToggleComponent,
    ContentComponent,
    FooterComponent,
    PageHeaderComponent,
    MobileNavComponent
]

const optionalComponents = [
    ThemeConfiguratorComponent
]

@NgModule({
    declarations: [
        ...mandatoryComponents,
        ...optionalComponents
    ],
    imports: [
        SharedModule,
        RouterModule,
        LogoModule,
      
        ModalModule.forRoot(),
        ButtonsModule.forRoot(),
        // SwitchModule,
        DropdownModule,
        PerfectScrollbarModule,
    ],
    exports: [
        AppLayoutComponent,
       
    ],
    providers: [],
})
export class LayoutModule {}